export default __webpack_public_path__ + "static/media/Euro.fb232017.svg";